import React, { useCallback } from 'react';
import { Formik, Form, FormikHelpers } from 'formik';

import { UserEmailData, UserResetPasswordData } from 'src/types/user';
import { resetPassValidationSchema } from 'app/viewModels/pages/ResetPasswordPageViewModel';
import { InputGroup } from 'app/components/common/InputGroup';
import { Button } from 'app/components/common/Button';

const initialPasswordValues = {
    password: '',
    confirmPassword: '',
};

type Props = {
    onSubmit: (data: UserResetPasswordData | UserEmailData) => void;
};

export const PasswordForm = ({ onSubmit }: Props) => {
    const onSubmitForm = useCallback((data: UserResetPasswordData, actions: FormikHelpers<UserResetPasswordData>) => {
        const { resetForm } = actions;

        if (onSubmit) {
            onSubmit(data);
        }

        resetForm();
    }, [onSubmit]);

    return (
        <Formik
            initialValues={initialPasswordValues}
            validationSchema={resetPassValidationSchema}
            onSubmit={onSubmitForm}
        >
            <Form>
                <InputGroup
                    id="inputPassword"
                    name="password"
                    autoComplete="new-password"
                    placeholder="Enter password"
                    label="New password"
                    type="password"
                />
                <InputGroup
                    id="confirmPassword"
                    name="confirmPassword"
                    autoComplete="new-password"
                    placeholder="Confirm password"
                    label="Confirm new password"
                    type="password"
                />

                <Button
                    className="reset-password-form__reset-btn"
                    type="submit"
                    text="Reset password"
                    size="big"
                />
            </Form>
        </Formik>
    );
};
